<script setup lang="ts">
import { FlexComponent, TypographyComponent } from '../../..'
withDefaults(
  defineProps<{
    label?: string
    align?: 'center' | 'top'
  }>(),
  { label: '', align: 'center' },
)
</script>
<template>
  <FlexComponent :gap="8" :align="align" justify="space-between">
    <slot name="label">
      <TypographyComponent variant="title-medium" :font-weight="600">{{ label }}</TypographyComponent>
    </slot>
    <slot />
  </FlexComponent>
</template>
